import {setStageSize} from '../../../reducers/stage-size';
import {STAGE_SIZE_MODES} from '../../../lib/layout-constants';
import {setFullScreen} from '../../../reducers/mode';

export default function stageMode ({mode}, _mode, _index) {
    return new Promise(resolve => {
        switch (mode) {
        case 'small':
            window.store.dispatch(setStageSize(STAGE_SIZE_MODES.small));
            break;
        case 'large':
            window.store.dispatch(setStageSize(STAGE_SIZE_MODES.large));
            break;
        case 'full':
            window.store.dispatch(setFullScreen(true));
            break
        case 'unfull':
            window.store.dispatch(setFullScreen(false));
            break;
        }
        resolve();
    });
}


const test = [{
    init:0,
    tips: "test",
    actions:[
        {
            action:'stageMode',
            params: {
                mode:'large'
            }
        },
        {
            action: 'showMsg',
            params: {
                msg: 'large'
            }
        },
        {
            action:'stageMode',
            params: {
                mode:'small'
            }
        },
        {
            action: 'showMsg',
            params: {
                msg: 'small'
            }
        },
        {
            action:'stageMode',
            params: {
                mode:'full'
            }
        },
        {
            action: 'showMsg',
            params: {
                msg: 'full'
            }
        },
        {
            action:'stageMode',
            params: {
                mode:'unfull'
            }
        },
        {
            action: 'showMsg',
            params: {
                msg: 'unfull'
            }
        },
    ]
}]
